import { IconProps } from "@assets/svg/types";
import { useTheme } from "@hooks";

export const Pending = ({ size = 24 }: IconProps) => {
  const { theme } = useTheme();

  const fill = theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0015 19.2007C9.99128 19.2007 8.28861 18.5031 6.89348 17.108C5.49835 15.7129 4.80078 14.0102 4.80078 12C4.80078 9.98981 5.49835 8.28715 6.89348 6.89202C8.28861 5.49688 9.99128 4.79932 12.0015 4.79932C14.0117 4.79932 15.7143 5.49688 17.1095 6.89202C18.5046 8.28715 19.2022 9.98981 19.2022 12C19.2022 14.0102 18.5046 15.7129 17.1095 17.108C15.7143 18.5031 14.0117 19.2007 12.0015 19.2007ZM12.0015 17.8506C13.6066 17.8506 14.983 17.2768 16.1306 16.1291C17.2782 14.9815 17.852 13.6052 17.852 12C17.852 10.3948 17.2782 9.01847 16.1306 7.87086C14.983 6.72325 13.6066 6.14945 12.0015 6.14945C10.3963 6.14945 9.01993 6.72325 7.87232 7.87086C6.72471 9.01847 6.15091 10.3948 6.15091 12C6.15091 13.6052 6.72471 14.9815 7.87232 16.1291C9.01993 17.2768 10.3963 17.8506 12.0015 17.8506Z"
        fill={fill}
      />
      <path
        d="M11.4288 16V12.5714H8V11.4286H11.4288L11.4283 8H12.5712L12.5717 11.4286H16V12.5714H12.5717V16H11.4288Z"
        fill={fill}
      />
    </svg>
  );
};
